import { useIonLoading } from '@ionic/react'
import { AxiosError, AxiosHeaders } from 'axios'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import {
  EVENTS,
  FLOW_ID,
  OBD_RESULT_CANCELLED,
  OBD_RESULT_NEGATIVE,
  OBD_RESULT_POSITIVE,
  OPERATION_TYPE,
  URL
} from '../../const/constants'
import { useAppContext } from '../../context/AppContext'
import { useStepsContext } from '../../context/StepsContext'
import useMessages from '../../hooks/useMessages'
import { COMPLETE_INPUT, newProcedureDate, obdResponse, saveDocumentId, simDataStore } from '../../redux/actions'
import { saveActivationDocument } from '../../services/api/dig-business-sales'
import { saveIntegrationLogs } from '../../services/api/dig-documents-manager'
import { checkOBDResult } from '../../services/api/portabilidad-api'
import { restoreLSData } from '../../utils/utils'

const CheckOBDResponse = () => {
  const procedure: string = location.pathname.split('/')[2]
  const flowId: any = new URLSearchParams(location.search).get(FLOW_ID)
  const { setBlockNavigation, setSettings, setUser }: any = useAppContext()
  const { setNewProcedureStep } = useStepsContext()
  const history = useHistory()
  const [present, dismiss] = useIonLoading()
  const dispatch = useDispatch()

  const { toastMessage } = useMessages()

  const redirectError = () => {
    history.push(`/procedures/validationError/${procedure}`)
  }

  const redirectSaveProcedureError = () => {
    history.push(`/procedures/${procedure}/error`)
  }

  const redirectCancelled = () => {
    setBlockNavigation(false)
    history.push(`/procedures/${procedure}`)
  }

  const continueActivation = async (request: Record<string, string>) => {
    setNewProcedureStep(3)
    try {
      const response = await saveActivationDocument(request)
      if (!response.data.success)
        throw new AxiosError(
          response.data.error,
          response.status.toString(),
          { url: '/businessSales/kiosk/activation/documents', headers: new AxiosHeaders() },
          request,
          response.data
        )

      dispatch(saveDocumentId(response.data.response.didId))
      toastMessage('Los datos se guardaron con éxito.', 3000, 'bottom', 'success')
      history.push(`/procedures/activaciones/nueva-activacion`)
    } catch (error) {
      if (error instanceof AxiosError)
        await saveIntegrationLogs({ ...error, event: EVENTS.saveActivation, user: request.user })
      redirectSaveProcedureError()
    }
  }
  const continuePortability = (user: Record<string, string>) => {
    setNewProcedureStep(2)
    dispatch({
      type: COMPLETE_INPUT,
      payload: {
        name: 'posNumberProcedure',
        value: user.posActivator,
        storeForm: 'lineValidationPYForm'
      }
    })
    history.push(`/procedures/portabilidades/nueva-portabilidad-py`)
  }

  const checkValidationResult = async () => {
    present({ message: `Validando resultado... <br/> Esperá por favor.` })
    try {
      const { initializedDate, ...obdData } = restoreLSData('preOBDData')
      const userData = restoreLSData('user')
      const settings = restoreLSData('settings')
      let simData = null
      let request = {}
      const user = obdData?.user || userData?.posNumber

      setSettings(settings)
      setUser(userData)

      localStorage.removeItem('preOBDData')

      const OBDResultResponse = await checkOBDResult({ operationType: OPERATION_TYPE[procedure], flowId, user })

      if (!OBDResultResponse.success) throw new Error('No se obtuvieron resultados para este flowId')

      if (OBDResultResponse.response.result === OBD_RESULT_NEGATIVE) redirectError()
      else if (OBDResultResponse.response.result === OBD_RESULT_CANCELLED) redirectCancelled()
      else if (OBDResultResponse.response.result === OBD_RESULT_POSITIVE) {
        if (obdData && Object.keys(obdData)?.length) {
          dispatch(obdResponse({ ...obdData, ...OBDResultResponse.response }))
          dispatch(newProcedureDate(initializedDate))
        }
        if (procedure === URL.activaciones) {
          simData = restoreLSData('simData')
          localStorage.removeItem('simData')

          request = {
            validationId: OBDResultResponse.response.flowId,
            birthDate: OBDResultResponse.response.data.birthDate,
            documentNumber: OBDResultResponse.response.identityNumber,
            documentType: OBDResultResponse.response.documentType,
            name: OBDResultResponse.response.data.name,
            lastName: OBDResultResponse.response.data.surname,
            country: OBDResultResponse.response.data.nationality,
            gender: OBDResultResponse.response.data.gender,
            simNumber: simData.simNumber,
            cellularNumber: simData.cellularNumber,
            user,
            posNumber: userData.posActivator,
            processInitializedDate: initializedDate
          }

          simData && dispatch(simDataStore(simData))
          await continueActivation(request)
        } else continuePortability(userData)
      }
    } catch (error) {
      console.log(error)
      redirectError()
    } finally {
      dismiss()
    }
  }

  useEffect(() => {
    setBlockNavigation(true)
    flowId && checkValidationResult()
  }, []) //eslint-disable-line

  return (
    <>
      <main></main>
    </>
  )
}

export default CheckOBDResponse
